module.exports = __webpack_public_path__ + "img/step2-en.282d0e3e.webp";